<template>
    <div>
        <h1>Playdate Questions</h1>
        <v-layout>
            <v-text-field v-model="value" solo label="Value"></v-text-field>
            <v-btn :disabled="(value!=null&&value!='')?false:true" @click="createQuestion" text color="success">add new Question</v-btn>
        </v-layout>
        <v-layout>
            <v-text-field @input="seatchMethod" v-model="search" solo label="Search"></v-text-field>
        </v-layout>
        <v-layout v-if="questions != null">
            <v-data-table
            v-if="questions.length"
            :headers="[
                /* { text: 'NUMBER', value: 'id_playlist' }, */
                { text: 'INDEX ORDER', value: 'index_order' },
                { text: 'Value', value: 'value' },
                { text: 'Suitable For', value: 'suitable_for' },
                { text: 'Min Age', value: 'minAge' },
                { text: 'Max Age', value: 'maxAge' },
                { text: 'EDIT', value: 'edit'},
                { text: 'DELETE', value: 'actions'},
                
                
            ]"
            :items="filteredQuestions"
            >
                <template v-slot:item.actions="{ item }">
                    <v-btn @click="deleteItem(item)" text color="error">DELETE</v-btn>
                </template>
                <template v-slot:item.edit="{ item }">
                    <v-btn @click="edit(item)" text color="info">Edit</v-btn>
                </template>
            </v-data-table>
    <v-dialog
        v-model="dialog"
        v-if="selected!=null"
        width="500"
    >
      <v-card>
        <v-card-title
            class="headline grey lighten-2"
            primary-title
        >
          Update question
        </v-card-title>

        <v-card-text>
          <v-text-field v-model="selected.value" label="Question"></v-text-field>
        </v-card-text>
        <v-card-text>
          <v-text-field v-model="selected.suitable_for" label="Suitable For" min="1" max="3" type="number" style="width:100px"></v-text-field>
        </v-card-text>
        <v-card-text>
            <v-text-field v-model="selected.minAge" label="Min Age" min="1" max="100" type="number" style="width:100px"></v-text-field>
        </v-card-text>
        <v-card-text>
            <v-text-field v-model="selected.maxAge" label="Max Age" min="1" max="100" type="number" style="width:100px"></v-text-field>
        </v-card-text>
        <v-card-text>
            <v-text-field v-model="selected.index_order" label="INDEX ORDER" type="number" style="width:100px"></v-text-field>
        </v-card-text>
        <v-divider></v-divider>


        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="success"
              flat
              @click="update"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
        </v-layout>
    </div>
</template>
<script>
import Axios from 'axios';

export default {
    data() {
        return {
            value: null,
            questions: null,
            filteredQuestions: null,
            search: '',
            selected: null,
            dialog:false,
        }
    },
    methods: {
        async update()
        {
            if(parseInt(this.selected.minAge) > parseInt(this.selected.maxAge))
            {
                console.log(this.selected)
                alert('Min age cannot be greater than max age.')
            }
            else
            {
                if(this.selected.value !=null && this.selected.value != "")
                {
                    await axios
                        .post("/admin/playdateQuestions/update", {
                            id: this.selected.id,
                            value: this.selected.value,
                            minAge: this.selected.minAge,
                            maxAge: this.selected.maxAge,
                            suitable_for: this.selected.suitable_for,
                            index_order: this.selected.index_order
                        }).then(()=>{
                            this.sync();
                            this.selected = null;
                            this.dialog = false;
                        })
                }
            }
        },
        edit(item)
        {
            this.selected = Object.assign({}, item);
            this.dialog = true;
        },
        seatchMethod(val)
        {
            if(this.search=='')
            {
                this.filteredQuestions = this.questions.sort((a, b) => {
  if (a.index_order === 0 && b.index_order !== 0) {
    return 1; // Если у "a" index_order равен 0, а у "b" не равен 0, поместите "a" в конец
  } else if (a.index_order !== 0 && b.index_order === 0) {
    return -1; // Если у "b" index_order равен 0, а у "a" не равен 0, поместите "b" в конец
  } else {
    return a.index_order - b.index_order; // Иначе сортируйте по index_order от меньшего к большему
  }
});
            }
            else
            {
                this.filteredQuestions = this.questions.filter(element => {
                return (element.value).includes(this.search)});
            }
        },
        async createQuestion() {
            if(this.value !=null && this.value != "")
            await axios
                .post("/admin/playdateQuestions/create", {
                    value: this.value
                }).then(()=>{
                    this.sync();
                    this.value = null;
                })
        },
        async deleteItem(item) {
            await axios
                .post("/admin/playdateQuestions/delete", item).then(()=>{
                    this.sync();
                })
        },
        async sync() {
            await axios
                .get("/admin/playdateQuestions/get").then((res)=>{
                    this.questions = res.data.sort((a, b) => {
  if (a.index_order === 0 && b.index_order !== 0) {
    return 1; // Если у "a" index_order равен 0, а у "b" не равен 0, поместите "a" в конец
  } else if (a.index_order !== 0 && b.index_order === 0) {
    return -1; // Если у "b" index_order равен 0, а у "a" не равен 0, поместите "b" в конец
  } else {
    return a.index_order - b.index_order; // Иначе сортируйте по index_order от меньшего к большему
  }
});

                    this.filteredQuestions = res.data.sort((a, b) => {
  if (a.index_order === 0 && b.index_order !== 0) {
    return 1; // Если у "a" index_order равен 0, а у "b" не равен 0, поместите "a" в конец
  } else if (a.index_order !== 0 && b.index_order === 0) {
    return -1; // Если у "b" index_order равен 0, а у "a" не равен 0, поместите "b" в конец
  } else {
    return a.index_order - b.index_order; // Иначе сортируйте по index_order от меньшего к большему
  }
});
                })
        },
    },
    created() {
        this.sync();
    }
}
</script>
<style lang="scss" scoped></style>